var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdateProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8889 11.1111C13.8889 8.16426 15.0595 5.33811 17.1433 3.25437C19.227 1.17063 22.0531 0 25 0C27.9468 0 30.773 1.17063 32.8567 3.25437C34.9405 5.33811 36.1111 8.16426 36.1111 11.1111C36.1111 14.058 34.9405 16.8841 32.8567 18.9679C30.773 21.0516 27.9468 22.2222 25 22.2222C22.0531 22.2222 19.227 21.0516 17.1433 18.9679C15.0595 16.8841 13.8889 14.058 13.8889 11.1111ZM13.8889 27.7778C10.2053 27.7778 6.67263 29.2411 4.06796 31.8457C1.46329 34.4504 0 37.9831 0 41.6667C0 43.8768 0.877974 45.9964 2.44078 47.5592C4.00358 49.122 6.1232 50 8.33333 50H41.6667C43.8768 50 45.9964 49.122 47.5592 47.5592C49.122 45.9964 50 43.8768 50 41.6667C50 37.9831 48.5367 34.4504 45.932 31.8457C43.3274 29.2411 39.7947 27.7778 36.1111 27.7778H13.8889Z",
    fill: "#FD0299"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateProfile);
export default __webpack_public_path__ + "static/media/UpdateProfile.6f893d71b422a318c71b8e10ea1ac0b4.svg";
export { ForwardRef as ReactComponent };